(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-drop"] && !Shopify.designMode) return;
  try {
    
  const initDropCountdowns = () => {
    document.querySelectorAll('[data-countdown]').forEach((section) => {
      if (section.dataset.countdownReady || !section.dataset.countdown) return;
      const target = new Date(section.dataset.countdown).getTime();
      if (Number.isNaN(target)) return;
      section.dataset.countdownReady = 'true';
      const fields = {
        days: section.querySelector('[data-days]'),
        hours: section.querySelector('[data-hours]'),
        minutes: section.querySelector('[data-minutes]'),
        seconds: section.querySelector('[data-seconds]')
      };
      const update = () => {
        const distance = Math.max(0, target - Date.now());
        const values = {
          days: Math.floor(distance / 86400000),
          hours: Math.floor(distance / 3600000) % 24,
          minutes: Math.floor(distance / 60000) % 60,
          seconds: Math.floor(distance / 1000) % 60
        };
        Object.entries(fields).forEach(([key, field]) => { if (field) field.textContent = String(values[key]).padStart(2, '0'); });
        if (distance === 0) clearInterval(timer);
      };
      const timer = setInterval(update, 1000);
      update();
    });
  };
  initDropCountdowns();
  document.addEventListener('shopify:section:load', initDropCountdowns);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const initProductSections = () => {
    document.querySelectorAll('[data-product-root]').forEach((root) => {
      if (root.dataset.productReady) return;
      root.dataset.productReady = 'true';
      const thumbs = root.querySelectorAll('[data-gallery-thumb]');
      const images = root.querySelectorAll('[data-gallery-image]');
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
        thumbs.forEach((item) => item.classList.remove('is-active'));
        images.forEach((item) => { item.hidden = item.dataset.galleryImage !== thumb.dataset.galleryThumb; });
        thumb.classList.add('is-active');
      }));
      const select = root.querySelector('select[name="id"]');
      const price = root.querySelector('.wy-pdp__price');
      const add = root.querySelector('button[name="add"]');
      if (select && add) select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        if (price) price.firstChild.textContent = option.dataset.price;
        const available = option.dataset.available === 'true';
        add.disabled = !available;
        add.textContent = available ? add.dataset.addLabel : add.dataset.soldLabel;
      });
    });
  };
  initProductSections();
  document.addEventListener('shopify:section:load', initProductSections);

  } catch(e) { console.error(e); }
})();
})();
